import { Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { Controller } from 'react-hook-form';

function PostalCode({
    name,
    control,
    errors,
    setValueinForm,
    setAddressValue,
    addressValues,
    setError = () => {},
    clearErrors = () => {},
    spacing = 1,
    selectedCountry,
}) {
    return (
        <Stack spacing={spacing}>
            <Typography
                variant="body1"
                style={{
                    fontWeight: 500,
                    fontSize: '16px',
                    lineHeight: '24px',
                    letterSpacing: '0.15px',
                }}
            >
                {selectedCountry?.country === 'United States' ? 'Zip Code' : 'Postal Code'}
            </Typography>
            <Controller
                name={name}
                control={control}
                render={({ field }) => (
                    <TextField
                        id="outlined-basic"
                        variant="outlined"
                        fullWidth
                        error={!!errors.postalCode}
                        helperText={errors.postalCode ? errors.postalCode.message : ''}
                        {...field}
                        inputProps={{
                            style: { textTransform: selectedCountry?.country === 'United States' ? 'none' : 'uppercase' },
                            maxLength: selectedCountry?.country === 'United States' ? 5 : 7,
                        }}
                        onChange={(e) => {
                            const input = e.target;
                            const rawValue = input.value;

                            const selectionStart = input.selectionStart || 0;
                            const prevValue = addressValues.postal || '';

                            // Country-specific processing
                            const isUSA = selectedCountry?.country === 'United States';
                            const cleaned = isUSA
                                ? rawValue.replace(/\D/g, '') // USA: digits only
                                : rawValue.replace(/\s/g, '').toUpperCase(); // Canada: remove spaces, uppercase

                            // Detect if user is deleting the space at index 3 (Canada only)
                            const isDeletingSpace = !isUSA && prevValue.charAt(selectionStart - 1) === ' ' && rawValue.length < prevValue.length;

                            // Format based on country
                            let formatted = cleaned;
                            if (!isUSA && cleaned.length > 3) {
                                formatted = cleaned.slice(0, 3) + ' ' + cleaned.slice(3, 6);
                            }

                            // Update form state
                            setValueinForm('postalCode', formatted);
                            setAddressValue({
                                ...addressValues,
                                postal: formatted,
                            });

                            // Country-specific validation
                            const isValidLength = isUSA ? formatted.length === 5 : formatted.length === 7;

                            if (!isValidLength) {
                                const errorMessage = isUSA ? 'Zip code is required - 5 digits' : 'Postal code is required - 6 digits';
                                setError(name, { message: errorMessage });
                            } else {
                                clearErrors(name);
                            }

                            // Adjust caret position
                            setTimeout(() => {
                                let newCursorPos = selectionStart;

                                // If inserting space automatically (Canada only)
                                if (!isUSA && !isDeletingSpace && cleaned.length === 4 && selectionStart === 4) {
                                    newCursorPos += 1;
                                }

                                // If user deleted the space, move cursor back
                                if (isDeletingSpace) {
                                    newCursorPos -= 1;
                                }

                                input.setSelectionRange(newCursorPos, newCursorPos);
                            }, 0);
                        }}
                    />
                )}
            />
        </Stack>
    );
}

export default PostalCode;
